function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M37.64,210.08A122,122,0,0,1,210.08,37.64l2.81-2.81A125.94,125.94,0,0,0,34.83,212.89Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M215.71,37.62l-2.81,2.81A122,122,0,0,1,40.43,212.9l-2.81,2.81A125.93,125.93,0,0,0,215.71,37.62Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M170.29,52.54A51.94,51.94,0,0,0,96.83,126Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M81.71,195a51.95,51.95,0,0,0,73.46-73.47Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M277.45,127.91q0-20.93,14-35.11,14-14.53,35.64-14.54,21.45,0,35.46,14.54a48.45,48.45,0,0,1,14.18,35.11q0,21.27-14,35.46-14,14.35-35.64,14.36t-35.64-14.36Q277.45,149.18,277.45,127.91Zm83.34,0A34.58,34.58,0,0,0,351,103.26a32.61,32.61,0,0,0-47.87,0,34.57,34.57,0,0,0-9.75,24.65,35,35,0,0,0,9.75,25,33,33,0,0,0,47.87,0A35,35,0,0,0,360.79,127.91Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M411.85,41.2V175.43H396.07V41.2Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M476.22,177.73q-18.62,0-29.44-10.81T436,137.48V80.56h15.78V137q0,12.24,6.47,19.15t18,6.91q11.52,0,18-6.91T500.69,137V80.56h15.78v56.92q0,18.61-10.73,29.44T476.22,177.73Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M575,175.25H562L529.57,80.56h16.49l23.05,72.52,26.6-72.52h11l27.48,72.52,22.16-72.52h16.49L641.1,175.25H628.16l-26.95-72.7Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M759.57,94.57v-14h15.25v94.87H759.57V161.77q-12.95,16-33.87,16-20.57,0-34-14.36-13.49-14.53-13.48-36t13.48-35.1q13.47-14,34-14Q746.45,78.26,759.57,94.57Zm1.24,33.34a35.49,35.49,0,0,0-9.4-24.83Q742.19,92.81,727.3,92.8t-24.12,10.28q-9,10.11-9,25,0,14.73,9,25,9.41,10.11,24.12,10.11t24.11-10.11A36.32,36.32,0,0,0,760.81,127.91Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M825.55,177.55a39.82,39.82,0,0,1-20.22-5.31A36.19,36.19,0,0,1,791,156.63L803,148.3a30.48,30.48,0,0,0,10.19,11.35,23.54,23.54,0,0,0,12.86,3.9q7.62,0,12.5-4a12.1,12.1,0,0,0,4.88-9.67q0-7.8-9.05-12.76-3.54-1.95-11.52-5.32-9-3.9-11.88-5.5-14.19-7.8-14.19-22.7A24.34,24.34,0,0,1,805,84.82q8.14-7.45,22-7.45a38.85,38.85,0,0,1,17.46,4,27.42,27.42,0,0,1,12.15,11.26L845.94,102q-7.28-11.17-20-11.17-6.55,0-10.28,3.45a11.26,11.26,0,0,0-3.73,8.6q0,7.81,7.81,11.53l10.81,5q8.34,3.56,12.41,5.68,16.14,8.51,16.14,23.94,0,11.88-9.4,20.21T825.55,177.55Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M964.54,126.31c0,1.3-.17,4.08-.53,8.33H887.94q2.13,12.95,10.64,20.57T922,162.84a55.75,55.75,0,0,0,17.47-3,62.48,62.48,0,0,0,16-7.8l6.74,12.24A63.23,63.23,0,0,1,944,173.74a67.82,67.82,0,0,1-22.35,3.81q-17,0-28.72-7.44t-16.67-18.36a57.23,57.23,0,0,1-5-24q0-21.45,13.3-35.46t34.39-14q20,0,32.81,12.94T964.54,126.31ZM939.1,100.24Q931,92.62,919,92.62a29.52,29.52,0,0,0-20.56,7.71q-8.52,7.73-10.47,20.13h59.94Q947.16,107.88,939.1,100.24Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M1017,153.26,1043,80.56h17.56L1020.52,187q-5.67,15.26-13.39,22a27.21,27.21,0,0,1-18.52,6.74q-9,0-14.72-3.55l1.77-14A28.85,28.85,0,0,0,987.19,201q11.87,0,18.79-16.85l3.73-9.22L968.57,80.56h18.26Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M1082.76,66.73a11.51,11.51,0,0,1-8.51-3.37,11.29,11.29,0,0,1-3.37-8.33,11,11,0,0,1,3.37-8.25,11.72,11.72,0,0,1,8.51-3.28,11.31,11.31,0,0,1,8.16,3.28,11.06,11.06,0,0,1,3.36,8.25,11.32,11.32,0,0,1-3.36,8.33A11.11,11.11,0,0,1,1082.76,66.73Zm7.62,13.83v94.87H1074.6V80.56Z"
})));

var SvgLogoFull = function SvgLogoFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1094.28 252",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-full.82fa53d0.svg";
export { ForwardRef as ReactComponent };